import React, { useRef, useState } from 'react';
import bannerImage from '../../../assets/images/theme_2.svg';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { ToasterService } from '../../../services/ToasterService';
import { useLocation } from 'react-router-dom';
import { AuthService } from '../../../services/AuthService';
import { STATUS_SUCCESS } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useLoader } from '../../../context/LoaderContext';
// import { requestForToken } from '../../../utils/getFcmToken';
const OTPVerifyPage: React.FC = () => {
  const navigate = useNavigate();
  const expireTime = localStorage.getItem('otpExpireAt');
  let remaining: any = 0;

  if (expireTime && expireTime !== '') {
    remaining = Math.floor((parseInt(expireTime) - Date.now()) / 1000);
  }
  const [timer, setTimer] = useState(remaining);
  const [canResend, setCanResend] = useState(false);

  React.useEffect(() => {
    if (remaining > 0) {
      setTimer(remaining);
      setCanResend(false);
    } else {
      setTimer(0);
      setCanResend(true);
    }
  }, []);

  React.useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setCanResend(true);
      localStorage.removeItem('otpExpireAt');
    }
  }, [timer]);

  useDocumentTitle('Namasteji Manikchand - OTP Verification');
  const location = useLocation();
  const { setLoading } = useLoader();
  const mobile = location.state?.mobile;
  const [otp, setOtp] = useState<string[]>(['', '', '', '']);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [otpError, setOtpError] = useState('');
  const otpRefs = useRef<Array<HTMLInputElement | null>>([]);

  // Handle input change
  const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value.replace(/\D/g, '');
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setOtpError('');
    if (value && index < 3) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  /** Handle  Handle backspace Button */
  const handleOtpBackspace = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = '';
        setOtp(newOtp);
      } else if (index > 0) {
        newOtp[index - 1] = '';
        setOtp(newOtp);
        otpRefs.current[index - 1]?.focus();
      }
    }
  };
  function generateFakeFcmToken() {
    const part1 = randomString(22);
    const part2 = randomString(120);
    return `${part1}:APA91b${part2}`;
  }

  function randomString(length: any) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const otpValue = otp.join('');
    if (otpValue.length !== 4) {
      setOtpError('Please enter the full 4-digit OTP');
      return;
    }
    // let fcm_token = await requestForToken();
    let fcm_token = '';
    if (!fcm_token || fcm_token === '' || fcm_token === undefined) {
      fcm_token = generateFakeFcmToken();
    }
    console.log('fcmToken', fcm_token);
    setButtonLoading(true);
    setLoading(true);
    try {
      const response = await AuthService.VerifyOtp(String(mobile), String(otpValue), String(fcm_token));
      if (response.message.status == STATUS_SUCCESS) {
        localStorage.setItem('userLoginData', JSON.stringify(response.message));
        localStorage.setItem('quotation_items', JSON.stringify(response.message.quotation_items));
        setLoading(false);
        setButtonLoading(true);
        navigate('/products');
        // window.location.reload();
      } else {
        setLoading(false);
        setButtonLoading(false);
        ToasterService.Error('Invalid OTP. Please try again.');
      }
    } catch (error) {
      setLoading(false);
      setButtonLoading(false);
      ToasterService.Error('Something went wrong');
    }
  };

  /** Call your API to resend OTP */
  const handleResendOTP = async () => {
    try {
      setLoading(true);
      const resp = await AuthService.UserLogin(mobile);
      console.log('Resend Otp resp', resp.message);
      if (resp.message.status === STATUS_SUCCESS) {
        setLoading(false);
        const newExpire = Date.now() + 60 * 1000;
        localStorage.setItem('otpExpireAt', newExpire.toString());
        setTimer(60);
        setCanResend(false);
        ToasterService.Success('OTP sent successfully!');
      } else {
        setLoading(false);
        ToasterService.Error('Server error. Please try again sometime!');
      }
    } catch (error) {
      setLoading(false);
      ToasterService.Error('Server error. Please try again sometime!');
    }
  };

  return (
    <div className='flex items-center justify-center bg-gray-100 px-6 py-12 sm:py-12 md:py-16 lg:py-16'>
      <div className='bg-white w-full max-w-xl rounded-xl shadow-lg overflow-hidden min-h-96 pb-6 sm:pb-6 md:pb-8 lg:pb-10'>
        {/* Top Banner */}
        <img src={bannerImage} alt='Manikchand Banner' className='w-full h-full object-cover' />

        {/* Form Section */}
        <div className='p-2 py-2 sm:p-2 sm:py-2 md:p-14 md:py-6 lg:p-16 lg:py-6'>
          <h2
            className='text-center text-xl sm:text-xl md:text-2xl lg:text-3xl 
          pt-6 sm:pt-6 md:pt-6 lg:pt-10 pb-3 sm:pb-3 md:pb-4 lg:pb-6 font-rubik 
          text-[#552B18] sm:text-[#552B18] md:text-[#552B18] lg:text-black'
          >
            OTP Verification
          </h2>
          <p className='text-center text-sm sm:text-sm md:text-base lg:text-base text-black mb-2 font-poppins'>
            We have sent a verification code to
          </p>
          <p className='text-center sm:text-sm md:text-base lg:text-base pb-4 sm:pb:4 md:pb-6 lg:pb-8 font-poppins font-semibold'>
            +91&nbsp;{mobile}
          </p>

          <form onSubmit={handleSubmit} className='px-6'>
            {/* OTP Inputs */}
            <div className='flex justify-center gap-4 mb-2 sm:mb-2 md:mb-3 lg:mb-4'>
              {[0, 1, 2, 3].map(index => (
                <input
                  key={index}
                  type='text'
                  inputMode='numeric'
                  maxLength={1}
                  className={`w-14 h-10 sm:h-10 md:h-12 lg:h-14 text-center text-2xl border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400 ${
                    otpError ? 'border-red-500' : 'border-gray-300'
                  }`}
                  value={otp[index]}
                  onChange={e => handleOtpChange(e, index)}
                  onKeyDown={e => handleOtpBackspace(e, index)}
                  ref={(el: any) => (otpRefs.current[index] = el)}
                />
              ))}
            </div>

            {/* Error message */}
            {otpError && (
              <p className='text-center text-sm text-red-500 font-poppins mb-2 sm:mb-2 md:mb-4 lg:mb-4'> {otpError}</p>
            )}

            <div className='text-center text-xs sm:text-xs md:text-sm lg:text-sm font-poppins mb-4 sm:mb-4 md:mb-6 lg:mb-6'>
              {canResend ? (
                <button type='button' onClick={handleResendOTP} className='text-blue-600 hover:underline'>
                  Resend OTP
                </button>
              ) : (
                <p className='text-gray-500'>Resend code (in {timer} sec)</p>
              )}
            </div>

            <button
              type='submit'
              disabled={buttonLoading}
              className='w-full bg-[#C12E2A] hover:bg-red-700 text-white py-2 sm:py-2 md:py-4 lg:py-4 rounded-xl text-base font-medium font-poppins transition duration-200'
            >
              {buttonLoading ? 'Processing...' : 'Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OTPVerifyPage;
